export default __webpack_public_path__ + "static/media/more-end-game.00fe514b.md";